'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormFields = undefined;

var _templateObject = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n'], ['\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  flex: 1 0 30%;\n  margin: auto;\n  padding-right: 30px;\n  padding-left: 10px;\n  padding-top: 5px;\n  padding-bottom: 5px;\n'], ['\n  flex: 1 0 30%;\n  margin: auto;\n  padding-right: 30px;\n  padding-left: 10px;\n  padding-top: 5px;\n  padding-bottom: 5px;\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Form = _styledComponents2.default.div(_templateObject);

var FormFields = exports.FormFields = _styledComponents2.default.div(_templateObject2);

exports.default = Form;


//////////////////
// WEBPACK FOOTER
// ./~/@rafacdb/bah/lib/Form.js
// module id = 102
// module chunks = 0